import { IActionHandler, IDispatcher } from './dispatcher.types';
import { ILogger } from '@dirootie-logging/logging-types';
import { SingleOrArray } from '@dirootie-extensions/typescript';
import { notEmptyArray, singleOrArrayToArray } from '@dirootie-extensions/javascript';
import { Action, IAction, IActionResult } from '@dirootie-web/components-types';
import { EventDi, IEvent, INotificationHandler } from './events.types';
import { forEach, prop } from 'ramda';

export class Dispatcher implements IDispatcher {
  private handlers: Map<string, IActionHandler> = new Map<
    string,
    IActionHandler
  >();

  private notifiers: Map<EventDi, INotificationHandler[]> = new Map<
  EventDi,
  INotificationHandler[]
>();
  constructor(private logger: ILogger) {}

  register(
    action: SingleOrArray<Action>,
    handler: IActionHandler<any, any>
  ): void {
    var actions = singleOrArrayToArray(action);
    actions.forEach((x) => this.handlers.set(x, handler));
  }

  dispatch(action: IAction): Promise<IActionResult> {
    this.logger.info('[Dispatcher:dispatch]: Called', action);
    const handler = this.handlers.get(action.action)!;
    if (handler) {
      return handler!.handle(action);
    }
    return Promise.reject({ isSuccess: false });
  }

  execute(action: IAction): Promise<any> {
    const handler = this.handlers.get(action.action)!;
    if (handler) {
      return handler!.handle(action);
    }
    return Promise.reject({ isSuccess: false });
  }

  notify(event: IEvent): void {
    this.logger.info('[Dispatcher:notify]: Called', event);
    const handlersNotifiers = this.notifiers.get(event.type)!;
    if (notEmptyArray(handlersNotifiers)) {
      forEach((x:INotificationHandler) => x.handle(event),handlersNotifiers);
    }

  }

  registerNotificationHandler(event: SingleOrArray<EventDi>, handler: INotificationHandler): void {
    var events = singleOrArrayToArray(event);
    events.forEach((x:EventDi) => {
      if (this.notifiers.has(x)) {
        this.notifiers.get(x)!.push(handler);
      }
      this.notifiers.set(x, [handler]);
    });
  }
}
